<template><div></div></template>
<script>
import ConsoleService from '../../services/console';
import DomainService from '../../services/domain'

export default {
	name: 'SSOLogin',
	data() {
		return {
			domain: null
		};
	},
	methods: {
		redirect(path) {
			this.$router.push({ path });
		},
		ssoLogin(data) {
			ConsoleService.instance().ssoLogin(data);
			DomainService.instance().getDomainConfig().then(response => {
				this.redirect(response.data.defaultPath);
			}).catch(e => e);
		},
		logout() {
			ConsoleService.instance().logout();
		},
	},
	mounted() {
		if (this.$route.query.token && this.$route.query.token.length > 0) {
			this.ssoLogin(this.$route.query.token);
		}
	}
};
</script>
